module.exports = __webpack_public_path__ + "img/start-ups-black.13a38e3f.svg";